module.exports = __webpack_public_path__ + "static/img/hand.9b8eaec4.svg";